import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/Front.png'
import _imports_1 from '@/assets/Back.png'
import _imports_2 from '@/assets/Left.png'
import _imports_3 from '@/assets/Right.png'


const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative border border-gray-200 dark:border-gray-700 bg-white dark:bg-black rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = { class: "grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = {
  for: "photo_front",
  class: "cursor-pointer block"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  src: _imports_0,
  alt: "Front View",
  class: "w-full h-16 object-contain rounded"
}
const _hoisted_12 = {
  key: 1,
  class: "mt-1 text-xs text-red-600 dark:text-red-400"
}
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = {
  for: "photo_back",
  class: "cursor-pointer block"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  src: _imports_1,
  alt: "Back View",
  class: "w-full h-16 object-contain rounded"
}
const _hoisted_17 = {
  key: 1,
  class: "mt-1 text-xs text-red-600 dark:text-red-400"
}
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  for: "photo_left",
  class: "cursor-pointer block"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  src: _imports_2,
  alt: "Left View",
  class: "w-full h-16 object-contain rounded"
}
const _hoisted_22 = {
  key: 1,
  class: "mt-1 text-xs text-red-600 dark:text-red-400"
}
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = {
  for: "photo_right",
  class: "cursor-pointer block"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 1,
  src: _imports_3,
  alt: "Right View",
  class: "w-full h-16 object-contain rounded"
}
const _hoisted_27 = {
  key: 1,
  class: "mt-1 text-xs text-red-600 dark:text-red-400"
}
const _hoisted_28 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_29 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_30 = {
  key: 0,
  class: "relative group"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 1,
  class: "relative group"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = {
  key: 2,
  class: "relative group"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 3,
  class: "relative group"
}
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "flex items-center justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { ref, computed, watch } from 'vue';
import { useToast } from 'vue-toastification';
import { useBrand } from '@/composables/brand/useBrand';
import type { Vehicle, VehicleFormData, VehiclePhoto } from '@/types/vehicle';

const MAX_PHOTOS = 4;

// Year options (1900 to current year + 1)

export default /*@__PURE__*/_defineComponent({
  __name: 'EditVehicleModal',
  props: {
    isOpen: { type: Boolean },
    vehicle: {},
    loading: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { brandColors } = useBrand();
const toast = useToast();

const emit = __emit;

// Form data
const formData = ref<VehicleFormData>({
  vehicle_make: '',
  vehicle_model: '',
  vehicle_year: new Date().getFullYear(),
  plate_number: ''
});

// Photo management - side-based structure
const existingPhotos = ref<Record<string, VehiclePhoto | null>>({
  front: null,
  back: null,
  left: null,
  right: null
});

const newPhotos = ref<Record<string, File | null>>({
  front: null,
  back: null,
  left: null,
  right: null
});

const deletedPhotoIds = ref<number[]>([]);
const errors = ref<Record<string, string>>({});

const yearOptions = computed(() => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear + 1; year >= 1900; year--) {
    years.push(year);
  }
  return years;
});

// Check if any new photos are selected
const hasNewPhotos = computed(() => {
  return Object.values(newPhotos.value).some(photo => photo !== null);
});

// Watch for vehicle changes to populate form and photos
watch(() => props.vehicle, (newVehicle) => {
  if (newVehicle) {
    formData.value = {
      vehicle_make: newVehicle.vehicle_make,
      vehicle_model: newVehicle.vehicle_model,
      vehicle_year: newVehicle.vehicle_year,
      plate_number: newVehicle.plate_number
    };

    // Reset photo structures
    existingPhotos.value = { front: null, back: null, left: null, right: null };
    newPhotos.value = { front: null, back: null, left: null, right: null };
    deletedPhotoIds.value = [];

    // Map existing photos by side
    if (newVehicle.vehicle_photos) {
      newVehicle.vehicle_photos.forEach(photo => {
        if (photo.photo_side) {
          existingPhotos.value[photo.photo_side as keyof typeof existingPhotos.value] = photo;
        }
      });
    }

    errors.value = {};
  }
}, { immediate: true });

// Handle photo selection/replacement for specific side
function handlePhotoSelect(side: 'front' | 'back' | 'left' | 'right', event: Event) {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files[0]) {
    const file = target.files[0];

    // Validate file type
    if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
      errors.value[`photo_${side}`] = 'Only JPEG, PNG, and JPG files are allowed';
      return;
    }

    // Validate file size (5MB max)
    if (file.size > 5 * 1024 * 1024) {
      errors.value[`photo_${side}`] = 'File size must not exceed 5MB';
      return;
    }

    newPhotos.value[side] = file;

    // Mark existing photo for deletion if replacing
    const existingPhoto = existingPhotos.value[side];
    if (existingPhoto && !deletedPhotoIds.value.includes(existingPhoto.vehicle_photo_id)) {
      deletedPhotoIds.value.push(existingPhoto.vehicle_photo_id);
    }

    errors.value[`photo_${side}`] = '';
  }
}

// Remove existing photo
function removeExistingPhoto(side: 'front' | 'back' | 'left' | 'right') {
  const photo = existingPhotos.value[side];
  if (photo && !deletedPhotoIds.value.includes(photo.vehicle_photo_id)) {
    deletedPhotoIds.value.push(photo.vehicle_photo_id);
    toast.info('Photo marked for deletion. Save to confirm.', { timeout: 3000 });
  }
}

// Remove new photo
function removeNewPhoto(side: 'front' | 'back' | 'left' | 'right') {
  newPhotos.value[side] = null;

  // If there was an existing photo that was marked for deletion, restore it
  const existingPhoto = existingPhotos.value[side];
  if (existingPhoto) {
    const index = deletedPhotoIds.value.indexOf(existingPhoto.vehicle_photo_id);
    if (index > -1) {
      deletedPhotoIds.value.splice(index, 1);
    }
  }
}

// Get photo preview URL for new photo
function getNewPhotoPreview(side: 'front' | 'back' | 'left' | 'right'): string | null {
  const file = newPhotos.value[side];
  return file ? URL.createObjectURL(file) : null;
}

function getPhotoUrl(path: string): string {
  const baseUrl = process.env.VUE_APP_API_URL || 'http://localhost:8000';
  // Below is for local
  // const baseUrl = process.env.VUE_APP_API_URL?.replace('/api', '') || 'http://localhost:8000';
  return `${baseUrl}/storage/${path}`;
}

function handleClose() {
  emit('close');
}

function handleSubmit() {
  if (props.vehicle) {
    errors.value = {};

    // Validate that all 4 side photos are covered (existing-not-deleted OR new upload)
    const sides = (['front', 'back', 'left', 'right'] as const);
    const sideLabels: Record<string, string> = {
      front: 'Front',
      back: 'Back',
      left: 'Left',
      right: 'Right',
    };
    let hasPhotoError = false;
    for (const side of sides) {
      const existingPhoto = existingPhotos.value[side];
      const existingOk =
        existingPhoto !== null &&
        !deletedPhotoIds.value.includes(existingPhoto!.vehicle_photo_id);
      const newOk = !!newPhotos.value[side];
      if (!existingOk && !newOk) {
        errors.value[`photo_${side}`] = `${sideLabels[side]} photo is required`;
        hasPhotoError = true;
      }
    }
    if (hasPhotoError) return;

    // Build File array and photoSides array from non-null sides
    const photoFiles: File[] = [];
    const photoSides: string[] = [];

    Object.entries(newPhotos.value).forEach(([side, file]) => {
      if (file) {
        photoFiles.push(file);
        photoSides.push(side);
      }
    });

    emit('save', props.vehicle.vehicle_id, { ...formData.value }, photoFiles, photoSides, deletedPhotoIds.value);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.vehicle)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _withModifiers(handleClose, ["self"])
            }, [
              _cache[40] || (_cache[40] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", { class: "sticky top-0 bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10" }, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 dark:bg-amber-900/20 flex items-center justify-center mr-3" }, [
                        _createElementVNode("svg", {
                          class: "h-5 w-5 text-amber-600 dark:text-amber-400",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          })
                        ])
                      ]),
                      _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Edit Vehicle ")
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: handleClose,
                      class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                    }, _cache[16] || (_cache[16] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
                    class: "px-6 py-4"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4" }, "Vehicle Information", -1)),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", {
                            for: "vehicle_make",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Vehicle Make "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "vehicle_make",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.vehicle_make) = $event)),
                            type: "text",
                            placeholder: "e.g., Toyota, Honda, Ford",
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white",
                            style: _normalizeStyle({ borderColor: _unref(brandColors).primary, '--tw-ring-color': _unref(brandColors).primary, 'outline': 'none' })
                          }, null, 4), [
                            [_vModelText, formData.value.vehicle_make]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[19] || (_cache[19] = _createElementVNode("label", {
                            for: "vehicle_model",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Vehicle Model "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "vehicle_model",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.vehicle_model) = $event)),
                            type: "text",
                            placeholder: "e.g., Camry, Civic, F-150",
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white",
                            style: _normalizeStyle({ borderColor: _unref(brandColors).primary, '--tw-ring-color': _unref(brandColors).primary, 'outline': 'none' })
                          }, null, 4), [
                            [_vModelText, formData.value.vehicle_model]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[21] || (_cache[21] = _createElementVNode("label", {
                            for: "vehicle_year",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Vehicle Year "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            id: "vehicle_year",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.vehicle_year) = $event)),
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white",
                            style: _normalizeStyle({ borderColor: _unref(brandColors).primary, '--tw-ring-color': _unref(brandColors).primary, 'outline': 'none' })
                          }, [
                            _cache[20] || (_cache[20] = _createElementVNode("option", {
                              value: "",
                              disabled: ""
                            }, "Select year", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (year) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: year,
                                value: year
                              }, _toDisplayString(year), 9, _hoisted_5))
                            }), 128))
                          ], 4), [
                            [
                              _vModelSelect,
                              formData.value.vehicle_year,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", {
                            for: "plate_number",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Plate Number "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "plate_number",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.plate_number) = $event)),
                            type: "text",
                            placeholder: "e.g., ABC-1234",
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white font-mono uppercase",
                            style: _normalizeStyle({ borderColor: _unref(brandColors).primary, '--tw-ring-color': _unref(brandColors).primary, 'outline': 'none' })
                          }, null, 4), [
                            [_vModelText, formData.value.plate_number]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _cache[37] || (_cache[37] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4" }, [
                        _createTextVNode(" Vehicle Photos "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _cache[38] || (_cache[38] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400 mb-4" }, " All 4 side photos are required (Front, Back, Left, Right). Click on existing photos to replace them. ", -1)),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("label", _hoisted_9, [
                            _createElementVNode("div", {
                              class: "border-2 border-dashed rounded-lg p-3 transition relative overflow-hidden",
                              style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                            }, [
                              (existingPhotos.value.front && !deletedPhotoIds.value.includes(existingPhotos.value.front.vehicle_photo_id))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: getPhotoUrl(existingPhotos.value.front.photo_path),
                                    alt: "Front View",
                                    class: "w-full h-16 object-cover rounded"
                                  }, null, 8, _hoisted_10))
                                : (_openBlock(), _createElementBlock("img", _hoisted_11))
                            ], 4),
                            _cache[24] || (_cache[24] = _createElementVNode("p", { class: "mt-2 text-sm font-medium text-gray-700 dark:text-gray-300" }, [
                              _createTextVNode(" FRONT "),
                              _createElementVNode("span", { class: "text-red-500" }, "*")
                            ], -1))
                          ]),
                          _createElementVNode("input", {
                            id: "photo_front",
                            type: "file",
                            accept: "image/jpeg,image/png,image/jpg",
                            class: "hidden",
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (handlePhotoSelect('front', $event)))
                          }, null, 32),
                          (existingPhotos.value.front && !deletedPhotoIds.value.includes(existingPhotos.value.front.vehicle_photo_id))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (removeExistingPhoto('front'))),
                                class: "mt-2 text-xs text-red-600 dark:text-red-400 hover:underline"
                              }, " Remove "))
                            : _createCommentVNode("", true),
                          (errors.value.photo_front)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(errors.value.photo_front), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, [
                            _createElementVNode("div", {
                              class: "border-2 border-dashed rounded-lg p-3 transition relative overflow-hidden",
                              style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                            }, [
                              (existingPhotos.value.back && !deletedPhotoIds.value.includes(existingPhotos.value.back.vehicle_photo_id))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: getPhotoUrl(existingPhotos.value.back.photo_path),
                                    alt: "Back View",
                                    class: "w-full h-16 object-cover rounded"
                                  }, null, 8, _hoisted_15))
                                : (_openBlock(), _createElementBlock("img", _hoisted_16))
                            ], 4),
                            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "mt-2 text-sm font-medium text-gray-700 dark:text-gray-300" }, [
                              _createTextVNode(" BACK "),
                              _createElementVNode("span", { class: "text-red-500" }, "*")
                            ], -1))
                          ]),
                          _createElementVNode("input", {
                            id: "photo_back",
                            type: "file",
                            accept: "image/jpeg,image/png,image/jpg",
                            class: "hidden",
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (handlePhotoSelect('back', $event)))
                          }, null, 32),
                          (existingPhotos.value.back && !deletedPhotoIds.value.includes(existingPhotos.value.back.vehicle_photo_id))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (removeExistingPhoto('back'))),
                                class: "mt-2 text-xs text-red-600 dark:text-red-400 hover:underline"
                              }, " Remove "))
                            : _createCommentVNode("", true),
                          (errors.value.photo_back)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errors.value.photo_back), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, [
                            _createElementVNode("div", {
                              class: "border-2 border-dashed rounded-lg p-3 transition relative overflow-hidden",
                              style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                            }, [
                              (existingPhotos.value.left && !deletedPhotoIds.value.includes(existingPhotos.value.left.vehicle_photo_id))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: getPhotoUrl(existingPhotos.value.left.photo_path),
                                    alt: "Left View",
                                    class: "w-full h-16 object-cover rounded"
                                  }, null, 8, _hoisted_20))
                                : (_openBlock(), _createElementBlock("img", _hoisted_21))
                            ], 4),
                            _cache[26] || (_cache[26] = _createElementVNode("p", { class: "mt-2 text-sm font-medium text-gray-700 dark:text-gray-300" }, [
                              _createTextVNode(" LEFT "),
                              _createElementVNode("span", { class: "text-red-500" }, "*")
                            ], -1))
                          ]),
                          _createElementVNode("input", {
                            id: "photo_left",
                            type: "file",
                            accept: "image/jpeg,image/png,image/jpg",
                            class: "hidden",
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (handlePhotoSelect('left', $event)))
                          }, null, 32),
                          (existingPhotos.value.left && !deletedPhotoIds.value.includes(existingPhotos.value.left.vehicle_photo_id))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (removeExistingPhoto('left'))),
                                class: "mt-2 text-xs text-red-600 dark:text-red-400 hover:underline"
                              }, " Remove "))
                            : _createCommentVNode("", true),
                          (errors.value.photo_left)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(errors.value.photo_left), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, [
                            _createElementVNode("div", {
                              class: "border-2 border-dashed rounded-lg p-3 transition relative overflow-hidden",
                              style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                            }, [
                              (existingPhotos.value.right && !deletedPhotoIds.value.includes(existingPhotos.value.right.vehicle_photo_id))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: getPhotoUrl(existingPhotos.value.right.photo_path),
                                    alt: "Right View",
                                    class: "w-full h-16 object-cover rounded"
                                  }, null, 8, _hoisted_25))
                                : (_openBlock(), _createElementBlock("img", _hoisted_26))
                            ], 4),
                            _cache[27] || (_cache[27] = _createElementVNode("p", { class: "mt-2 text-sm font-medium text-gray-700 dark:text-gray-300" }, [
                              _createTextVNode(" RIGHT "),
                              _createElementVNode("span", { class: "text-red-500" }, "*")
                            ], -1))
                          ]),
                          _createElementVNode("input", {
                            id: "photo_right",
                            type: "file",
                            accept: "image/jpeg,image/png,image/jpg",
                            class: "hidden",
                            onChange: _cache[10] || (_cache[10] = ($event: any) => (handlePhotoSelect('right', $event)))
                          }, null, 32),
                          (existingPhotos.value.right && !deletedPhotoIds.value.includes(existingPhotos.value.right.vehicle_photo_id))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (removeExistingPhoto('right'))),
                                class: "mt-2 text-xs text-red-600 dark:text-red-400 hover:underline"
                              }, " Remove "))
                            : _createCommentVNode("", true),
                          (errors.value.photo_right)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(errors.value.photo_right), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (hasNewPhotos.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _cache[36] || (_cache[36] = _createElementVNode("h5", { class: "text-md font-semibold text-gray-900 dark:text-white mb-3" }, " New Photos to Upload ", -1)),
                            _createElementVNode("div", _hoisted_29, [
                              (newPhotos.value.front)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createElementVNode("img", {
                                      src: getNewPhotoPreview('front')!,
                                      alt: "New Front Photo",
                                      class: "w-full h-32 object-cover rounded-lg border-2 border-blue-300 dark:border-blue-600"
                                    }, null, 8, _hoisted_31),
                                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "absolute top-2 left-2 bg-black/70 text-white px-2 py-1 rounded text-xs font-semibold uppercase" }, " FRONT ", -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (removeNewPhoto('front'))),
                                      class: "absolute top-2 right-2 p-1.5 bg-red-500 hover:bg-red-600 rounded-full shadow-lg transition-all duration-200"
                                    }, _cache[28] || (_cache[28] = [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 text-white",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M6 18L18 6M6 6l12 12"
                                        })
                                      ], -1)
                                    ]))
                                  ]))
                                : _createCommentVNode("", true),
                              (newPhotos.value.back)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("img", {
                                      src: getNewPhotoPreview('back')!,
                                      alt: "New Back Photo",
                                      class: "w-full h-32 object-cover rounded-lg border-2 border-blue-300 dark:border-blue-600"
                                    }, null, 8, _hoisted_33),
                                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "absolute top-2 left-2 bg-black/70 text-white px-2 py-1 rounded text-xs font-semibold uppercase" }, " BACK ", -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (removeNewPhoto('back'))),
                                      class: "absolute top-2 right-2 p-1.5 bg-red-500 hover:bg-red-600 rounded-full shadow-lg transition-all duration-200"
                                    }, _cache[30] || (_cache[30] = [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 text-white",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M6 18L18 6M6 6l12 12"
                                        })
                                      ], -1)
                                    ]))
                                  ]))
                                : _createCommentVNode("", true),
                              (newPhotos.value.left)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("img", {
                                      src: getNewPhotoPreview('left')!,
                                      alt: "New Left Photo",
                                      class: "w-full h-32 object-cover rounded-lg border-2 border-blue-300 dark:border-blue-600"
                                    }, null, 8, _hoisted_35),
                                    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "absolute top-2 left-2 bg-black/70 text-white px-2 py-1 rounded text-xs font-semibold uppercase" }, " LEFT ", -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (removeNewPhoto('left'))),
                                      class: "absolute top-2 right-2 p-1.5 bg-red-500 hover:bg-red-600 rounded-full shadow-lg transition-all duration-200"
                                    }, _cache[32] || (_cache[32] = [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 text-white",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M6 18L18 6M6 6l12 12"
                                        })
                                      ], -1)
                                    ]))
                                  ]))
                                : _createCommentVNode("", true),
                              (newPhotos.value.right)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createElementVNode("img", {
                                      src: getNewPhotoPreview('right')!,
                                      alt: "New Right Photo",
                                      class: "w-full h-32 object-cover rounded-lg border-2 border-blue-300 dark:border-blue-600"
                                    }, null, 8, _hoisted_37),
                                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "absolute top-2 left-2 bg-black/70 text-white px-2 py-1 rounded text-xs font-semibold uppercase" }, " RIGHT ", -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (removeNewPhoto('right'))),
                                      class: "absolute top-2 right-2 p-1.5 bg-red-500 hover:bg-red-600 rounded-full shadow-lg transition-all duration-200"
                                    }, _cache[34] || (_cache[34] = [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 text-white",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M6 18L18 6M6 6l12 12"
                                        })
                                      ], -1)
                                    ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: handleClose,
                        disabled: _ctx.loading,
                        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                      }, " Cancel ", 8, _hoisted_39),
                      _createElementVNode("button", {
                        type: "submit",
                        disabled: _ctx.loading,
                        class: "px-4 py-2 text-white rounded-lg transition-all duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
                        style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                      }, [
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_41, _cache[39] || (_cache[39] = [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }, null, -1),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Saving...' : 'Save Changes'), 1)
                      ], 12, _hoisted_40)
                    ])
                  ], 32)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})